<template>
  <div class="landing">
    <div class="bg"></div>

    <carousel class="carousel" />
    
    <div class="content">
      <span class="logo">
        <webp-image src="https://cdn.llscdn.com/fe-static/lls-with-tfchina/logo-w215ppgN.png" alt="logo" width="100%" />
      </span>
      <h2 class="title"></h2>
      <div class="date">活动时间：<strong>2017.11.24 - 2017.12.7</strong></div>
      <p>参加活动期间，你每学习 <strong>5</strong> 分钟，流利说将为美丽中国支教项目农村学生捐赠 <strong>1</strong> 节免费人工智能课程</p>
      <p><small>感谢「真爱梦想·一扇窗」公益专项基金对本次活动开展的大力支持。</small></p>
    </div>
    <touch v-if="!this.externalChannels" tag="button" class="start" :class="{ active: open }" type="button" @tap="joinTheActivity" >{{ status }}</touch>
    <touch class="start active" v-else @tap="openApp">
      <open-app :download="'https://a.app.qq.com/o/simple.jsp?pkgname=com.liulishuo.engzo&ckey=CK1381148873550'" >立即参加</open-app>
    </touch>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import actions from '@/store/action-types'

  import WebpImage from '@/components/common/WebpImage'
  import Carousel from '@/components/Carousel'
  import OpenApp from '@/components/common/OpenApp'

  export default {
    name: 'landing',
    computed: {
      ...mapState({
        externalChannels: state => state.activity.externalChannels,
        joined: state => state.activity.joined,
        status: state => state.activity.status,
        open: state => state.activity.open
      })
    },
    created () {
      this.getActivityStatus()
    },
    methods: {
      getActivityStatus () {
        if (!this.externalChannels) {
          if (this.joined) {
            this.gotoDonate()
          } else {
            this.$store.dispatch(actions.fetch.LATEST_DONATE)
            this.$track.sendPageTrack('csr_sign_up')
          }
        } else {
          this.$track.sendPageTrack('csr_download')
        }
      },
      joinTheActivity () {
        if (this.open) {
          this.$store.dispatch(actions.post.JOININ_ACTIVITY).then(() => {
            this.$track.sendActionTrack('csr_sign_up', 'click_sign_up')
            this.gotoDonate()
          })
        }
      },
      openApp () {
        this.$track.sendActionTrack('csr_download', 'click_download')
      },
      gotoDonate () {
        if (this.joined) {
          this.$router.replace('donate')
        }
      }
    },
    components: {
      WebpImage,
      Carousel,
      OpenApp
    }
  }
</script>

<style lang="scss" scoped>
  @import '../assets/scss/vars';

  $landingBg: 'https://cdn.llscdn.com/fe-static/lls-with-tfchina/bg-g2pXXVj2.jpg';
  $landingTitle: 'https://cdn.llscdn.com/fe-static/lls-with-tfchina/title-xxRABsZH.png';

  .landing {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 30px;
    box-sizing: border-box;
    .bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-image: url($landingBg);
      background-size: cover;
      background-position: center;
      box-sizing: border-box;
    }
    .carousel {
      position: relative;
      z-index: 3;
    }
    .content {
      position: absolute;
      left: 0;
      bottom: 138px;
      z-index: 2;
      padding-left: 50px;
      padding-right: 50px;
    }
    .logo {
      display: block;
      width: 388px;
      height: 75px;
      margin-bottom: 20px;
      font-size: 0;
    }
    .title {
      width: 538px;
      height: 82px;
      text-indent: -999px;
      background-image: url($landingTitle);
      background-size: cover;
      background-repeat: no-repeat;
    }
    .date {
      margin-top: 30px;
      margin-bottom: 30px;
      font-size: 30px;
      color: $white;
      line-height: 42px;
    }
    p {
      margin-bottom: 20px;
      font-size: 30px;
      line-height: 42px;
      color: $white;
      small {
        font-size: 24px;
        color: rgba($white, 0.64);
        line-height: 32px;
      }
    }
    strong {
      font-weight: normal;
      color: $darkRed;
    }
    .start {
      @include reset-button;
      position: fixed;
      left: 0;
      bottom: 0;
      z-index: 99;
      width: 100%;
      height: 98px;
      color: rgba($black, 0.54);
      font-size: 36px;
      font-weight: 400;
      text-align: center;
      line-height: 98px;
      background-color: #cccccc;
      &.active {
        color: $white;
        background-color: $red;
      }
    }
  }
  body[data-webp='support'] {
    .landing {
      background-image: url($landingBg + '?imageMogr2/format/webp');
      .title {
        background-image: url($landingTitle + '?imageMogr2/format/webp');
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Landing.vue?e54edc36